<template>
  <transition
    enter-active-class="transform transition duration-300 ease-custom"
    enter-class="translate-y-1/2 scale-y-0 opacity-0"
    enter-to-class="-translate-y-0 scale-y-100 opacity-100"
    leave-active-class="transform transition duration-300 ease-custom"
    leave-class="-translate-y-0 scale-y-100 opacity-100"
    leave-to-class="translate-y-1/2 scale-y-0 opacity-0"
  >
    <div
      v-show="openMenuNotification"
      :style="$screen.portrait ? 'min-width: 350px' : 'min-width: 350px'"
      :class="$screen.portrait ? 'bottom-full	' : 'bottom-16'"
      class="border-ontick-carbon-500 bg-ontick-steel-500 absolute left-16 z-40 overflow-hidden rounded-md border-b shadow-lg"
    >
      <ul style="max-height: 400px" class="relative w-full overflow-y-auto">
        <li
          v-for="(item, index) in notification_stream"
          :key="index"
          @click="useClick = !useClick"
          :class="
            index % 2 === 0 ? 'bg-ontick-steel-500' : 'bg-ontick-steel-700'
          "
          class="w-full px-4 py-3"
        >
          <dd class="flex items-baseline justify-between">
            <div
              v-if="item.hasOwnProperty('datetime')"
              class="flex items-baseline text-xs text-gray-400"
            >
              {{ item.datetime | moment("DD/MM/YYYY HH:mm:ss") }}
            </div>
            <div
              v-if="item.hasOwnProperty('time')"
              class="flex items-baseline text-xs text-gray-400"
            >
              {{ item.time }}
            </div>
            <span
              class="bg-ontick-blue-800 text-ontick-blue-300 inline-flex items-center rounded bg-opacity-25 px-2 py-0.5 text-xs font-medium uppercase"
            >
              {{ item.topic }}
            </span>
          </dd>
          <p
            class="trucante py-1 text-left text-sm font-semibold text-gray-300"
          >
            {{ item.title }}
          </p>
          <p class="text-left text-xs text-gray-300 md:block">
            <expandable-text-line class="text" :use-click="useClick">
              <span v-html="item.message"></span>
            </expandable-text-line>
          </p>
        </li>

        <div v-show="notification_stream.length == 0" class="py-4 text-center">
          <div class="flex justify-center">
            <span class="h-10 w-10 text-gray-300" v-html="$icons.chat"></span>

            <p class="px-2 py-3 text-center text-xs normal-case text-gray-300">
              Nenhuma notificação
            </p>
          </div>
        </div>
      </ul>
      <div class="relative bottom-0 w-full">
        <button
          @click="notificationsRead()"
          :disabled="notification_stream.length == 0"
          v-show="notification_stream.length != 0"
          class="bg-ontick-blue-900 hover:bg-ontick-blue-800 inline-flex w-full items-center justify-center py-2 text-center text-xs font-bold text-gray-300"
        >
          <span class="pr-1" v-html="$icons.check_verify"></span>
          Marcar todas como lidas
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ClickOutside from "vue-click-outside";
import Favico from "favico.js-slevomat";
import { Howl, Howler } from "howler";

var favicon = new Favico({
  bgColor: "#dd5b5b",
  textColor: "#fff",
});

export default {
  name: "notification_navbar",

  directives: {
    ClickOutside,
  },

  components: {
    ExpandableTextLine: () => import("vue-expandable-text-line"),
  },

  props: {
    openMenuNotification: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      notification: [],
      useClick: false,
      read: false,
      hover_notification: false,
      date_notification: "",
    };
  },

  computed: {
    ...mapState({
      notification_stream: (state) => state.notification.notification_stream,
      accountTypes: (state) => state.accountTypes,
      play_sound: (state) => state.config.play_sound,
    }),
  },

  methods: {
    ...mapActions({
      getNotificationTransient: "notification/getNotificationTransient",
      postTransientDismiss: "notification/postTransientDismiss",
    }),

    playSound() {
      // var sound = new Howl({
      //   src: [
      //     "../../../assets/magic.wav",
      //     "http://soundbible.com/mp3/Cash Register Cha Ching-SoundBible.com-184076484.mp3",
      //   ],
      //   // src:["../../../assets/magic.wav"],
      //   autoplay: true,
      //   loop: false,
      //   html5: true,
      //   volume: 0.5,

      //   onend: function () {
      //     console.log("Finished!");
      //   },
      // });
      // sound.play();
      const audio = new Audio("./magic.wav");
      audio.play();
    },

    notificationsRead() {
      this.postTransientDismiss().then(() => favicon.badge(0));
    },
  },

  watch: {
    notification_stream: {
      handler(newmessage, oldmessage) {
        favicon.badge(newmessage.length);
        if (this.play_sound != "OFF" && newmessage.length > oldmessage.length) {
          // this.playSound();
        }
        return newmessage;
      },
    },
  },

  mounted() {
    this.getNotificationTransient();
    favicon.badge(this.notification_stream.length);

    document.addEventListener("click", () => {
      const audioContext = new AudioContext();
      audioContext.resume();
      // this.playSound();
    });
  },
};
</script>

<style lang="scss">
@import "@/app/assets/scss/_framework";

.close_button {
  color: #3498db;
}

/* Applied to the toast body when using regular strings as content */
.Vue-Toastification__toast-body.custom-class-1 {
  font-size: 30px;
}
/* Applied to a wrapper div when using a custom component as content */
.Vue-Toastification__toast-component-body.custom-class-2 {
  width: 100%;
}

.Vue-Toastification__toast--default.notification {
  @apply bg-ontick-steel-100 dark:bg-ontick-carbon-600 bg-opacity-90 backdrop-blur-sm backdrop-opacity-90 backdrop-filter dark:bg-opacity-90 dark:backdrop-blur-sm dark:backdrop-opacity-90 dark:backdrop-filter;
}
</style>
